export const Companies = () => {
    return <div>Companies</div>;
};